// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"8fe48bff","703":"36a7d379"}[chunkId] + ".chunk.js";
};